// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const ProfileMenuDivider = styled.div `
  border-top: 1px solid var(--color-neutral-300);
  margin: 0px 16px 0px;
`;
export const ProfileMenuContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  visibility: hidden;
  opacity: 0;
  width: 320px;
  padding: 8px 0px;
  top: 56px;
  right: 26px;
  z-index: 1;
  background-color: var(--color-neutral-100);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
  transition: opacity 0.3s ease-out;

  &.open {
    visibility: visible;
    opacity: 1;
  }
  .profile-menu-option_item {
    display: flex;
    align-items: center;
    padding: 7px 0px 7px 20px;
    gap: 24px;
    cursor: pointer;

    &.disabled {
      cursor: not-allowed;
      path {
        fill: var(--color-neutral-200);
      }
      span {
        color: var(--color-neutral-200);
      }
    }

    &:not(.disabled) {
      &:hover {
        background-color: var(--color-action-hover);
      }
    }

    &.logout:hover {
      background-color: var(--color-feedback-danger-200);
    }

    span {
      font-size: var(--font-size-default);
      color: var(--color-neutral-600);
    }
  }
  .profile-menu_user {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 24px;

    .username {
      font-size: var(--font-size-default);
      color: var(--color-neutral-500);
      font-weight: var(--font-weight-semibold);
      line-height: 150%;
    }
    .email {
      font-size: var(--font-size-sm);
      color: var(--color-neutral-500);
      line-height: 20px;
    }
  }
`;
//# sourceMappingURL=style.js.map